interface SubRouteLayoutProps {
  children: React.ReactNode;
}

export const SubRouteLayout: React.FC<SubRouteLayoutProps> = ({ children }) => {
  return <>{children}</>;
};
